import { Provider } from 'react-redux';
import React, { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import HeaderFooter from '../header-footer/HeaderFooter';
import {
  CommunicationSection,
  CsvData,
  FooterLink,
  HeaderFunctions,
  QuickviewService,
  ReduxState,
  SkuFavoriteService,
} from '../../types';
import { setCommonState } from '../../store/slices/common';
import {
  setHeaderTaxo,
  setProgressiveHeaderTaxo,
  setHeaderFeaturedTaxo,
} from '../../store/slices/taxonomy';
import { getStore } from '../../store/store';

import 'pages/csr-header-footer/injectNavigation';

declare global {
  export interface Window {
    headerData: {
      storeIdentifierName: string;
      csvData: CsvData[];
      communicationSection?: CommunicationSection;
      footerLinks?: FooterLink[];
      searchApi?: string;
      thumbnailApi?: string;
      tickerApi?: string;
    };
    headerReduxData: ReduxState;
    cartCountComponent?: {
      setCartCount: (value: string | number) => void;
    };
    headerFunctions: HeaderFunctions;
    quickview: QuickviewService;
    skuFavorite: SkuFavoriteService;
  }
}

const store = getStore();

if (window.headerReduxData) {
  if (window.headerReduxData.taxonomy.header) {
    store.dispatch(setHeaderTaxo(window.headerReduxData.taxonomy.header));
  }
  if (window.headerReduxData.taxonomy.progressiveHeader) {
    store.dispatch(setProgressiveHeaderTaxo(window.headerReduxData.taxonomy.progressiveHeader));
  }
  if (window.headerReduxData.taxonomy.headerFeatured) {
    store.dispatch(setHeaderFeaturedTaxo(window.headerReduxData.taxonomy.headerFeatured));
  }
  store.dispatch(setCommonState(window.headerReduxData.common));
}

hydrateRoot(
  document.getElementById('responsive-header') as HTMLElement,
  <StrictMode>
    <Provider store={store}>
      <HeaderFooter route="header" store={store} />
    </Provider>
  </StrictMode>,
);
